/**
 * Navbar — Compatibilité ascendante (refonte 2026-02).
 *
 * Historiquement, ~45 pages importaient `@/components/Navbar`. Pour
 * unifier l'expérience CONFILEX en UN seul header (cf. directive
 * "un seul menu de navigation"), ce module ré-exporte désormais le
 * `BookingNavbar` officiel. Aucune autre page n'a besoin d'être
 * modifiée — toutes héritent automatiquement de la nouvelle barre.
 *
 * NE PAS rajouter de logique ici. Pour modifier la nav :
 *   → /app/frontend/src/components/booking/BookingNavbar.jsx
 */
import BookingNavbar from "@/components/booking/BookingNavbar";

export default BookingNavbar;
